import router from '@/router';
import { register as registerApi, login as loginApi, getUserInfo as getUserInfoApi, smsLogin as smsLoginApi } from '@/api/auth';

const state = {
  token: localStorage.getItem('token') || '',
  tokenType: localStorage.getItem('tokenType') || '',
  userInfo: JSON.parse(localStorage.getItem('userInfo')) || null,
  role: localStorage.getItem('userRole') || '',
  roles: []
};

const mutations = {
  SET_TOKEN(state, { token, tokenType }) {
    state.token = token;
    state.tokenType = tokenType;
    localStorage.setItem('token', token);
    localStorage.setItem('tokenType', tokenType);
  },
  SET_USER_INFO(state, userInfo) {
    state.userInfo = userInfo;
    localStorage.setItem('userInfo', JSON.stringify(userInfo));
  },
  SET_ROLE(state, role) {
    state.role = role;
    localStorage.setItem('userRole', role);
    sessionStorage.setItem('userRole', role);
    console.log('用户角色已保存:', role);
  },
  LOGOUT(state) {
    state.token = '';
    state.tokenType = '';
    state.userInfo = null;
    state.role = '';
    localStorage.removeItem('token');
    localStorage.removeItem('tokenType');
    localStorage.removeItem('userInfo');
    localStorage.removeItem('userRole');
    sessionStorage.removeItem('userRole');
    localStorage.removeItem('currentCampus');
  },
  SET_ROLES(state, roles) {
    state.roles = roles;
  }
};

const actions = {
  // 登录
  login({ commit }, userInfo) {
    const { username, password, role, schoolCode, isQuestionBank } = userInfo;
    
    // 准备登录请求数据
    const loginData = {
      username,
      password,
      role: isQuestionBank ? role : role,
      schoolCode: schoolCode || userInfo.school_code
    };
    
    console.log('Vuex登录操作开始，数据:', loginData);
    console.log('是否题库系统登录:', isQuestionBank);
    
    return new Promise((resolve, reject) => {
      // 调用登录API
      loginApi(loginData)
        .then(response => {
          console.log('登录API返回结果:', response);
          
          // 由于响应拦截器已经处理了通用格式，这里直接获取token信息
          // response现在应该是data部分的内容
          const { access_token, token_type } = response;
          
          if (access_token && token_type) {
            // 将token和token类型保存到状态中
            commit('SET_TOKEN', { 
              token: access_token, 
              tokenType: token_type 
            });
            
            // 保存用户角色 - 从登录表单获取
            commit('SET_ROLE', role);
            
            // 创建一个临时用户对象，后续可通过getUserInfo获取完整信息
            const tempUserInfo = {
              username,
              role
            };
            commit('SET_USER_INFO', tempUserInfo);
            
            resolve(tempUserInfo);
          } else {
            // 响应格式不符合预期
            console.error('响应格式不符合预期:', response);
            reject(new Error('登录响应格式错误'));
          }
        })
        .catch(error => {
          console.error('登录请求失败详细信息:', error);
          // 根据状态码提供更详细的错误信息
          let errorMessage = '登录失败，请重试';
          
          if (error.response) {
            const status = error.response.status;
            console.log('错误状态码:', status);
            
            // 如果有错误响应数据，优先使用
            if (error.response.data && error.response.data.msg) {
              errorMessage = error.response.data.msg;
            } else {
              switch (status) {
                case 401:
                  errorMessage = '用户名或密码错误';
                  break;
                case 403:
                  errorMessage = '用户未激活';
                  break;
                case 404:
                  errorMessage = '用户未在此学校注册';
                  break;
                default:
                  errorMessage = '登录失败，请重试';
              }
            }
          }
          
          reject(new Error(errorMessage));
        });
    });
  },
  
  // 短信验证码登录
  smsLogin({ commit }, loginData) {
    const { phone, smsCode, role, schoolCode, isQuestionBank } = loginData;
    
    // 准备登录请求数据
    const smsLoginData = {
      phone,
      smsCode,
      role: isQuestionBank ? role : role,
      schoolCode: schoolCode || loginData.school_code
    };
    
    console.log('Vuex短信登录操作开始，数据:', smsLoginData);
    console.log('是否题库系统登录:', isQuestionBank);
    
    return new Promise((resolve, reject) => {
      // 调用短信登录API
      smsLoginApi(smsLoginData)
        .then(response => {
          console.log('短信登录API返回结果:', response);
          
          // 由于响应拦截器已经处理了通用格式，这里直接获取token信息
          const { access_token, token_type } = response;
          
          if (access_token && token_type) {
            // 将token和token类型保存到状态中
            commit('SET_TOKEN', { 
              token: access_token, 
              tokenType: token_type 
            });
            
            // 保存用户角色 - 从登录表单获取
            commit('SET_ROLE', role);
            
            // 创建一个临时用户对象，后续可通过getUserInfo获取完整信息
            const tempUserInfo = {
              phone,
              role
            };
            commit('SET_USER_INFO', tempUserInfo);
            
            resolve(tempUserInfo);
          } else {
            // 响应格式不符合预期
            console.error('响应格式不符合预期:', response);
            reject(new Error('登录响应格式错误'));
          }
        })
        .catch(error => {
          console.error('短信登录请求失败详细信息:', error);
          // 根据状态码提供更详细的错误信息
          let errorMessage = '登录失败，请重试';
          
          if (error.response) {
            const status = error.response.status;
            console.log('错误状态码:', status);
            
            // 如果有错误响应数据，优先使用
            if (error.response.data && error.response.data.msg) {
              errorMessage = error.response.data.msg;
            } else {
              switch (status) {
                case 401:
                  errorMessage = '验证码错误或已过期';
                  break;
                case 403:
                  errorMessage = '用户未激活';
                  break;
                case 404:
                  errorMessage = '手机号未注册或未在此学校注册';
                  break;
                default:
                  errorMessage = '登录失败，请重试';
              }
            }
          }
          
          reject(new Error(errorMessage));
        });
    });
  },
  
  // 注册
  register({ commit }, userInfo) {
    return new Promise((resolve, reject) => {
      // 调用实际的注册API
      registerApi(userInfo)
        .then(response => {
          console.log('注册API返回数据:', response);
          
          // 由于响应拦截器已经处理了通用格式，这里将直接获取数据部分
          // response是data部分的内容
          if (response) {
            console.log('注册成功，用户数据:', response);
            resolve(response);
          } else {
            console.error('响应格式不符合预期:', response);
            reject(new Error('注册响应格式错误'));
          }
        })
        .catch(error => {
          console.error('注册请求失败:', error);
          // 直接传递错误对象，不再包装一次
          reject(error);
        });
    });
  },
  
  // 登出
  logout({ commit }) {
    return new Promise(resolve => {
      commit('LOGOUT');
      // 不再自动跳转到登录页
      resolve();
    });
  },
  
  // 更新用户信息
  updateUserInfo({ commit, state }, newInfo) {
    // 合并现有用户信息和新提供的信息
    const updatedInfo = { ...state.userInfo, ...newInfo };
    commit('SET_USER_INFO', updatedInfo);
    return Promise.resolve(updatedInfo);
  }
};

const getters = {
  isAuthenticated: state => !!state.token,
  userRole: state => state.role,
  userName: state => state.userInfo ? state.userInfo.username : '',
  userAvatar: state => state.userInfo ? state.userInfo.avatar : '',
  roles: state => state.roles
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}; 